import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgStressGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M38.99 27.87c-2.37-2.36-2.4-3.62-2.44-5.71-.03-1.52-.07-3.4-1.06-6.17-2.12-5.9-8.58-8-13.92-8-4.54.01-8.41 1.79-10.9 5.02-2.62 3.4-3.34 7.97-2.05 12.86a.75.75 0 1 0 1.45-.39c-1.17-4.42-.53-8.53 1.79-11.55 2.2-2.86 5.64-4.43 9.7-4.43 4.83 0 10.65 1.84 12.51 7.01.91 2.53.94 4.21.98 5.69.05 2.21.08 3.95 2.89 6.74.35.34.48.56.54.67-.19.11-.62.22-.87.29-.75.2-1.68.45-1.8 1.31-.03.24-.01.55.02 1.01.09 1.33.25 3.82-1.04 5.2-.67.72-1.72 1.09-3.1 1.09h-1c-1.4 0-2.73.01-3.93-.06a.75.75 0 1 0-.08 1.5c.97.05 1.99.06 3.06.06h1.96c1.81 0 3.22-.53 4.19-1.56 1.74-1.85 1.54-4.76 1.44-6.32-.01-.19-.03-.41-.03-.56.17-.08.5-.16.7-.22.77-.21 1.74-.46 1.97-1.33.21-.84-.46-1.63-.98-2.15Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M23.01 18.77a.75.75 0 0 0-.98-.4.75.75 0 0 0-.4.98l1.65 3.89h-3.06c-.25 0-.49.13-.63.34-.14.21-.16.48-.06.71l2.1 4.94a.746.746 0 0 0 .98.4c.38-.16.56-.6.4-.98l-1.65-3.89h3.06c.25 0 .49-.13.63-.34.14-.21.16-.48.06-.71l-2.1-4.94Z",
    fill: "currentColor"
  }));
}

export { SvgStressGlyphSecondary as default };
